exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".open-edit:hover {\n  color: #1464f6; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/trip-reservations/edit-reservation/edit-billing/components/info-trip-billing/info-trip-billing.component.scss
// module id = 2123
// module chunks = 66